import animation, { fadeIn, fadeInUp } from '@helpers/animation';
import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { headerOverlap, headerOverlapPadding } from '@helpers/utils';
import HeadingStyles from '@stories/Components/Global/Typography/Heading.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled, { css } from 'styled-components';
const Container = styled(SectionWrapper) `
  ${headerOverlap};
  ${headerOverlapPadding};
  ${setCssVar('accentColor', brand.gold)};

  @media ${from(Device.TabletLarge)} {
    ${() => BackLink} {
      opacity: 0;
    }

    ${() => Subtitle} {
      opacity: 0;
      transform: translateY(40px);

      &:before {
        transform: scaleX(0);
        transform-origin: left;
        transition: transform 375ms ${animation.easeInOutCubic} 200ms;
      }
    }

    ${() => Title} {
      opacity: 0;
      transform: translateY(40px);
    }

    ${() => Image} {
      transform: scale(1.1);
      transition: transform 500ms ease-out;
    }

    ${({ isActive }) => isActive &&
    css `
        ${BackLink} {
          ${fadeIn(isActive, 375, 0, animation.easeInOutCubic)};
        }

        ${() => Subtitle} {
          ${fadeInUp(isActive, 40, 375, 0, animation.easeInOutCubic)};

          &:before {
            transform: scaleX(1);
          }
        }

        ${() => Title} {
          ${fadeInUp(isActive, 40, 375, 150, animation.easeInOutCubic)};
        }

        ${() => Image} {
          transform: scale(1);
        }
      `}
  }
`;
const ContentWrapper = styled.div `
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding: 20px 0 32px;

  @media ${from(Device.Tablet)} {
    padding: 32px 0 112px;
  }
`;
const BackLink = styled.a `
  display: block;
  color: currentColor;
  text-decoration: none;
  margin: 0 0 48px;

  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;
const BackIcon = styled.span `
  display: inline-block;
  height: 10px;
  margin: 0 4px 0 0;
  transform: rotate(180deg);
  transform-origin: center center;
  width: 10px;
`;
const Subtitle = styled.time `
  position: relative;
  display: block;
  border: 0;
  ${fonts.workSans.medium};
  font-size: 14px;
  letter-spacing: 0.146em;
  line-height: 16px;
  margin: 0 0 10px;
  padding: 0 0 6px;
  text-transform: uppercase;

  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    border-bottom: 1px solid ${cssVar('accentColor')};
  }

  @media ${from(Device.Tablet)} {
    font-size: 14px;
    line-height: 16px;
  }

  @media ${from(Device.Desktop)} {
    font-size: 20px;
    line-height: 24px;
    margin: 0 0 8px;
    padding: 0 0 10px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 23px;
    line-height: 27px;
  }
`;
const Title = styled.h1 `
  display: block;
  ${HeadingStyles.H3Styles};
  margin: 0;
  max-width: 693px;
`;
const ImageWrapper = styled.div `
  position: relative;
  height: 0;
  padding-bottom: ${(199 / 375) * 100}%;

  @media ${from(Device.TabletLarge)} {
    padding-bottom: ${(817 / 1920) * 100}%;
    overflow: hidden;
  }
`;
const Image = styled.img `
  position: absolute;
  left: 0;
  top: 0;
  display: block;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  width: 100%;
`;
export default {
    BackIcon,
    BackLink,
    Container,
    ContentWrapper,
    Image,
    ImageWrapper,
    Subtitle,
    Title,
};
